const button_years = { 2027: true, 2028: false }

angular
  .module("myApp")
  .controller("ProjectApplicationController", function ($scope, $state, JaunsPieteikums) {
    this.openPp = (row) => {
      if (row.versija_id) {
        $state.go("app.application.edit", {
          id: row.versija_id,
        })
      } else if (row.id) {
        $state.go("app.application.edit", {
          id: row.id,
        })
      } else {
        $state.go("app.application.new")
      }
    }

    $scope.view = "petniecibas_pieteikums_list"
    $scope.gridOptions = {
      filtersUrl: "pages/pp/pp-filter.html",
      actionsTemplateUrl: "pages/pp/pp-buttons.html",
      defaultFilters: {},
      initialFilters: {},
      noDataLabel: "Nav atrasts neviens pieteikums.",
      rowClick: this.openPp,

      years: button_years,
      cb_createSaimniecisks: (y) => {
        const pp = new JaunsPieteikums({ pieteikuma_gads: +y, ar_saimniecisku_darbibu_saistits: true })
        pp.$create(() => {
          $state.go("app.application.edit.open", { id: pp.id })
        }, $scope.failing)
      },
      cb_createNesaimniecisks: (y) => {
        const pp = new JaunsPieteikums({ pieteikuma_gads: +y, ar_saimniecisku_darbibu_saistits: false })
        pp.$create(() => {
          $state.go("app.application.edit.open", { id: pp.id })
        }, $scope.failing)
      },
    }
    if ($state.current.name === "app.application.list-melnraksti") {
      $scope.gridOptions.filtersUrl = undefined
    }
    if ($state.current.name === "app.application.list") {
      $state.params.initialFilters = {
        flt_melnraksts: false,
        flt_iesniegts: false,
      }
    }
    if ($state.current.name === "app.application.list-melnraksti") {
      $scope.gridOptions.filtersUrl = "pages/filter-text.html"
      $state.params.fixedFilters = {
        flt_melnraksts: true,
        flt_iesniegts: false,
        flt_apstiprinats: false,
        flt_noraidits: false,
      }
    }
    if ($state.current.name === "app.application.list-iesniegtie") {
      $scope.gridOptions.filtersUrl = "pages/filter-text.html"
      $state.params.fixedFilters = {
        flt_melnraksts: false,
        flt_iesniegts: true,
        flt_apstiprinats: false,
        flt_noraidits: false,
      }
    }
  })
  .controller("ProjectApplicationMgrAssignedController", ($scope, $state) => {
    $scope.view = "petniecibas_pieteikums_mgr_assigned_list"
    $scope.gridOptions = {
      noDataLabel: "Nav atrasts neviens pieteikums.",
      rowClick: (row) =>
        $state.go("app.submissions.edit", {
          id: row.id,
        }),
    }
  })

  .controller("ProjectApplicationMgrController", ($scope, $state, Dialog, JaunsPieteikumsMgr) => {
    const make_pieteikums = (pieteikuma_gads, ar_saimniecisku_darbibu_saistits) => {
      Dialog.dialog(
        "pages/dialogs/org-choose.form.html",
        {
          title: "Jauna pieteikuma manuāla ievade",
        },
        (dto) => {
          dto.pieteikuma_gads = pieteikuma_gads
          dto.ar_saimniecisku_darbibu_saistits = ar_saimniecisku_darbibu_saistits
          const pp = new JaunsPieteikumsMgr(dto)
          pp.$create(() => {
            $state.go("app.application.edit.open", { id: pp.id })
          }, $scope.failing)
        }
      )
    }

    $scope.view = "petniecibas_pieteikums_mgr_list"
    $scope.gridOptions = {
      filtersUrl: "pages/pp/pp-mgr-filter.html",
      actionsTemplateUrl: "pages/pp/pp-buttons.html",
      initialFilters: {},
      noDataLabel: "Nav atrasts neviens pieteikums.",
      rowClick: (row) =>
        $state.go("app.submissions.edit", {
          id: row.id,
        }),

      years: button_years,
      cb_createSaimniecisks: (y) => {
        make_pieteikums(y, true)
      },
      cb_createNesaimniecisks: (y) => {
        make_pieteikums(y, false)
      },
    }

    if ($state.current.name === "app.submissions.list") {
      $scope.gridOptions.filtersUrl = "pages/filter-text.html"
      $state.params.initialFilters = {
        flt_mine: false,
        flt_iesniegts: true,
        flt_noraidits: false,
        flt_apstiprinats: false,
        flt_lzp: "any",
      }
    }

    if ($state.current.name === "app.submissions.list-lzp") {
      $state.params.initialFilters = {
        flt_mine: false,
        flt_iesniegts: false,
        flt_noraidits: false,
        flt_apstiprinats: false,
        flt_lzp: "true",
      }
    }
    if ($state.current.name === "app.submissions.list-assigned") {
      $state.params.initialFilters = {
        flt_mine: true,
        flt_iesniegts: false,
        flt_noraidits: false,
        flt_apstiprinats: false,
        flt_lzp: "any",
      }
    }
    if ($state.current.name === "app.submissions.list-all") {
      $state.params.initialFilters = {
        flt_melnraksts: true,
        flt_iesniegts: true,
        flt_apstiprinats: true,
        flt_noraidits: true,
        flt_mine: true,
        flt_lzp: "any",
      }
    }
  })
